export default __webpack_public_path__ + "static/media/letmelove.16b0b4b4.mp3";